import axios from "axios";
// import _ from 'lodash';

const baseURL = process.env.REACT_APP_SANHA_BACKEND_BASEURL;
const apiKey = "$2a$12$SBwY7/26mvyBhGUQ6vDs6.zSVQnaebKp4q.sc2mfY7DXPRBQRlKaG";
const vendorId = process.env.REACT_APP_VENDOR_ID;
const systemId = process.env.REACT_APP_SYSTEM_ID;
const bsnsCode = process.env.REACT_APP_BSNS_CODE;
const propertyNo = process.env.REACT_APP_PROPERTY_NO;

// config
const request = axios.create({
  baseURL,
  timeout: 30000,
});

const headers = (header) => {
  return {
    headers: {
      "API-KEY": apiKey,
      VENDOR_ID: vendorId,
      "Content-Type": "application/json",
      ...(header && header),
    },
  };
};

const querystring = (query) => {
  return {
    params: query,
  };
};

export const listBooking = ({ rsvnNo: reservationNo }) => {
  return request.get(`/ays/v1/${systemId}/reservation/${bsnsCode}/${propertyNo}`, {
    ...headers(),
    ...querystring({
      reservationNo,
    }),
  });
};

export const selectCheckedInBooking = ({ folioNo }) => {
  return request.get(`/ays/v1/${systemId}/inhouse/${bsnsCode}/${propertyNo}/${folioNo}`, {
    ...headers(),
  });
};
